import { BaseCard, PrimaryButton, StatusError } from "../../../library";
import { IconName } from "../../../library/components/icons/iconNames";
import { StatusErrorTone } from "../../../library/properties/IErrorProperties";
import RightsReserved from "../landing/RightsReserved";
import { errorLayoutStyles } from "./ErrorLayoutStyles";

interface IErrorLayoutProps {
  statusCode?: string;
  statusText?: string;
  helpText?: string;
  tone?: StatusErrorTone;
  icon?: IconName | string;
  /** Optional CTA button. Omit both to render an action-less error (e.g. maintenance). */
  actionTitle?: string;
  onAction?: () => void | Promise<void>;
}

/**
 * Shared scaffold for every full-screen error state (401 / 403 / network /
 * server / activation / unexpected) in the learner app. Owns the glass card,
 * brand logo, a vertically-centered error block (icon pill + code + message +
 * help) and the rights-reserved footer, so each screen only supplies content.
 */
const ErrorLayout = ({
  statusCode,
  statusText,
  helpText,
  tone = "danger",
  icon,
  actionTitle,
  onAction,
}: IErrorLayoutProps) => {
  return (
    <BaseCard>
      <style>{errorLayoutStyles}</style>
      <img
        className="elo-logo"
        src="/logos/logo-primary.webp"
        alt="logo"
        style={{ objectFit: "contain" }}
      />
      <div className="elo-main">
        <StatusError
          statusCode={statusCode}
          statusText={statusText}
          tone={tone}
          icon={icon}
          helpText={helpText}
        />
        {actionTitle && onAction ? (
          <div className="elo-action">
            <PrimaryButton
              title={actionTitle}
              size="medium"
              iconPosition="right"
              onClick={onAction}
            />
          </div>
        ) : null}
      </div>
      <div className="elo-footer">
        <RightsReserved />
      </div>
    </BaseCard>
  );
};

export default ErrorLayout;
